import {
    Button,
    Checkbox,
    Collapse,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import { useState } from "react";
import {
    SurveyQuestionAnswerInput,
    SurveyQuestionDto,
    SurveyQuestionType,
} from "../../../api/psc";

type TProps = {
    question: SurveyQuestionDto;
    state: SurveyQuestionAnswerInput[];
    selectQuestionOption: (questionId: number, optionId: number) => void;
    setQuestionNote: (questionId: number, note: string) => void;
};

export default function SurveyQuestion({
    question,
    selectQuestionOption,
    state,
    setQuestionNote: setQuestionNote,
}: TProps) {
    const [notesOpen, setNotesOpen] = useState(false);

    const getQuestionState = (questionId: number) => {
        return state.find((a) => a.questionId === questionId);
    };

    return (
        <>
            <Typography>{question.question}</Typography>
            <Stack direction="row" spacing={1}>
                <FormControl sx={{ flex: 1 }}>
                    <InputLabel
                        id={`label-${question.id}-${question.question}`}
                    >
                        انتخاب کنید...
                    </InputLabel>
                    <Select
                        labelId={`label-${question.id}-${question.question}`}
                        defaultValue=""
                        multiple={
                            question.type === SurveyQuestionType.MULTI_SELECT
                        }
                        label="انتخاب کنید..."
                    >
                        {question.options.map((option) => (
                            <MenuItem
                                key={option.id}
                                value={option.id}
                                onClick={() =>
                                    selectQuestionOption(question.id, option.id)
                                }
                            >
                                {question.type ===
                                    SurveyQuestionType.MULTI_SELECT && (
                                    <Checkbox />
                                )}
                                {option.option}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <Button
                    sx={{ borderRadius: 3 }}
                    onClick={() => setNotesOpen((prev) => !prev)}
                    variant="outlined"
                >
                    نیاز به توضیح دارد
                </Button>
            </Stack>
            <Collapse in={notesOpen} orientation="vertical" collapsedSize="0px">
                <TextField
                    onChange={(e) =>
                        setQuestionNote(question.id, e.target.value)
                    }
                    value={getQuestionState(question.id).notes}
                    label="توضیحات"
                    sx={{ width: "100%" }}
                />
            </Collapse>
        </>
    );
}
